import { Component, Input, forwardRef, Output, EventEmitter } from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';

@Component({
  selector: 'app-button',
  templateUrl: './button.component.html',
  styleUrls: ['./button.component.less']
})
export class ButtonComponent{
  @Input() label: string;
  @Input() className: string;
  @Input() showSpinner: boolean;
  @Input() disabled: boolean;
  @Output() onClick = new EventEmitter<any>();

  constructor() {}

  onClickButton(event) {
    if(this.showSpinner) event.stopPropagation();
      this.onClick.emit(event);
  }
}
